const AttentionType = [
   { descr: 'Particular', id: 1 },
   { descr: 'Obra Social', id: 2 },
];

export { AttentionType };
